import { render, staticRenderFns } from "./left_menu_bar.vue?vue&type=template&id=4d25809d&scoped=true"
import script from "./left_menu_bar.vue?vue&type=script&lang=js"
export * from "./left_menu_bar.vue?vue&type=script&lang=js"
import style0 from "./left_menu_bar.vue?vue&type=style&index=0&id=4d25809d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d25809d",
  null
  
)

export default component.exports